import { AppSettings } from '@/AppSettings';
import { IThemeCreationOptions } from '@/contexts/styles/ThemeActionContext';
import { grey } from '@mui/material/colors';
import { ThemeOptions } from '@mui/material/styles';

const DefaultBeforeThemeCreated: IThemeCreationOptions['beforeThemeCreated'] = (themeOptions, chosenTheme) => {
    let newOptions: ThemeOptions = {
        ...themeOptions,
        palette: {
            ...themeOptions.palette,
            primary: {
                main: chosenTheme === 'dark' ? AppSettings.palette.primaryDark : AppSettings.palette.primaryLight
            },
            secondary: {
                main: chosenTheme === 'dark' ? AppSettings.palette.secondaryDark : AppSettings.palette.secondaryLight 
            }
        }
    };

    if (chosenTheme !== 'dark') {
        if (!newOptions.palette) {
            newOptions.palette = {}
        }

        newOptions.palette.background = {
            default: grey[200]
        }
    }



    return newOptions;
};

export default DefaultBeforeThemeCreated;